import type { SafetyProfileFaqItem } from "@miter/types/common";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "ui2";

import { ProfileSection } from "safety/components/profile/ProfileSection";

type FaqSectionProps = {
  faqs: SafetyProfileFaqItem[];
};

export const FaqSection = ({ faqs }: FaqSectionProps): React.JSX.Element => (
  <ProfileSection title="Frequently asked">
    <Accordion type="multiple" className="tw:gap-0">
      {faqs.map((faq, index) => (
        <AccordionItem
          key={index}
          value={String(index)}
          className="tw:rounded-none tw:border-0 tw:border-b tw:border-stroke tw:bg-transparent tw:last:border-b-0"
        >
          <AccordionTrigger className="tw:font-sans tw:text-sm tw:font-medium tw:text-midnight">
            {faq.question}
          </AccordionTrigger>
          <AccordionContent>
            <p className="tw:m-0 tw:text-sm tw:leading-relaxed tw:text-midnight/75">{faq.answer}</p>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </ProfileSection>
);
